<template>
  <v-card color="grey lighten-2">
    <v-card-title class="text-center">Manuscript Versions</v-card-title>
    <v-divider></v-divider>
    <v-list color="grey lighten-5" two-line>
      <div v-for="(version, index) in versions" :key="version._id">
        <v-list-item>
          <v-list-item-content>
            <v-list-item-subtitle class="text--primary">
              <small>Submitted on {{ formatDate(version.submittedAt) }}</small>
            </v-list-item-subtitle>

            <v-list-item-subtitle
              v-text="version.manuscriptStatus"
            ></v-list-item-subtitle>
          </v-list-item-content>

          <v-list-item-action>
            <v-list-item-action-text v-if="manuscript._id == version._id">
              <strong class="text-uppercase">This version</strong>
            </v-list-item-action-text>

            <v-btn icon v-else :to="`./${version._id}`">
              <v-icon color="grey lighten-1"> mdi-open-in-new </v-icon>
            </v-btn>
          </v-list-item-action>
        </v-list-item>

        <v-divider v-if="index < versions.length - 1" :key="index"></v-divider>
      </div>
    </v-list>
  </v-card>
</template>

<script>
import { formatDate } from "../../../tools/format";
export default {
  props: {
    versions: { type: Array, default: () => [] },
    manuscript: { type: Object, default: () => {} },
  },

  methods: {
    formatDate,
  },
};
</script>

<style>
</style>
